import type { IntlShape } from 'react-intl';

import {
	DefaultExtensionProvider,
	type ExtensionProvider,
} from '@atlaskit/editor-common/extensions';
import type { ProviderFactory } from '@atlaskit/editor-common/provider-factory';
import type { PublicPluginAPI } from '@atlaskit/editor-common/types';

import {
	type AgentManagedExtensionPlugin,
	AGENT_MANAGED_EXTENSION_TYPE_DEFAULT,
} from '../common/agentManagedExtensionPluginType.ts';
import { getAgentManagedExtensionManifest } from './manifest';

/**
 * Returns an `ExtensionProvider` exposing the agent-managed bodied
 * extension to the editor framework. Consumers compose this into their
 * `combineExtensionProviders(...)` list. Rebuild on locale change so
 * the localized quick-insert title/description are re-formatted.
 *
 * @param editorAPI
 * @param extensionType - Product-specific extension type namespace.
 *   Defaults to `AGENT_MANAGED_EXTENSION_TYPE_DEFAULT` (Confluence).
 * @param intl
 * @param providerFactory
 */
type AgentManagedExtensionProviderConfig = {
	editorAPI?: PublicPluginAPI<[AgentManagedExtensionPlugin]>;
	extensionType?: string;
	intl: IntlShape;
	providerFactory?: ProviderFactory;
};

export const getAgentManagedExtensionProvider = ({
	editorAPI,
	extensionType = AGENT_MANAGED_EXTENSION_TYPE_DEFAULT,
	intl,
	providerFactory,
}: AgentManagedExtensionProviderConfig): ExtensionProvider =>
	new DefaultExtensionProvider([
		getAgentManagedExtensionManifest({
			editorAPI,
			extensionType,
			intl,
			providerFactory,
		}),
	]);
